import * as React from "react";
import { User, Role } from "../../api/classes";
import Table from "./table";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import Loading from "../../components/loading";

interface Props {
  users: User[];
  roles: Role[];
  fetchRoles: () => void;
  fetchUsers: () => void;
}
class Users extends React.Component<Props> {
  componentWillMount() {
    if (!this.props.users) {
      this.props.fetchUsers();
    }
    if (!this.props.roles) {
      this.props.fetchRoles();
    }
  }
  render() {
    if (!this.props.users || !this.props.roles) {
      return <Loading />;
    }
    return (
      <div
        style={{
          flex: 1,
          padding: 24,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflowY: "scroll"
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 1000,
            marginLeft: 24,
            marginRight: 24
          }}
        >
          <Table
            classes={{}}
            elements={this.props.users}
            roles={this.props.roles}
          />
        </div>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({
    users: state.cases.users,
    roles: state.cases.roles
  }),
  dispatch => ({
    fetchUsers: (): any => dispatch(actions.fetchUsers()),
    fetchRoles: (): any => dispatch(actions.fetchRoles())
  })
)(Users);



// WEBPACK FOOTER //
// ./src/pages/users/index.tsx